// The prompt texts, bundled for the page: the contract document and each kind pack's example.
// Vite's ?raw import inlines the file as a string. Keep this list in step with KIND_PACKS.

import type { PromptSources } from "../gen/stages.js";
import contract from "../gen/contract.md?raw";
import agar from "../../games/agar/game.js?raw";
import tethered from "../../games/tethered/game.js?raw";
import burrow from "../../games/burrow/game.js?raw";
import allotment from "../../games/allotment/game.js?raw";
import crewed from "../../games/crewed/game.js?raw";

const EXAMPLES: Record<string, string> = { agar, tethered, burrow, allotment, crewed };

export const browserSources: PromptSources = {
  contract,
  example(slug) {
    const s = EXAMPLES[slug];
    if (s === undefined) throw new Error(`no bundled example for "${slug}"; add it to runtime/client/gensources.ts`);
    return s;
  },
};
